import {
    BlockVisibilityProtocol,
    FieldADTValue,
    FilterFormType,
    RecordLikeProtocol,
    VariableADTvalue,
    VISIBILITY_STATUS
} from '@lighthouse/core'
import React from 'react'

import type { ComplexDataOfVariableAndJSONContentData, ParseVariableOptions } from '../../types'
import type { ContainerHighlight, FlowLayoutNode, LayoutProperty, NodeIdWithScope, NodeRenderProps } from './types'

// 栅格基础属性
export interface FlowLayoutContextValue extends Partial<Omit<LayoutProperty, 'viewLayout'>> {
    rootElement?: HTMLDivElement | null
    data: FlowLayoutNode[]
    selectedNodes?: NodeIdWithScope[]
    disabled?: boolean
    nodeRender?: (props: NodeRenderProps) => JSX.Element | null
    highlight?: Record<string, ContainerHighlight | undefined>
    scale?: number
    sortable?: boolean
    useParseVariableWithSubscription: (
        data?: ComplexDataOfVariableAndJSONContentData
    ) => (args_0: VariableADTvalue | undefined, args_1?: ParseVariableOptions) => FieldADTValue | undefined
    useVisibilityFilter: (
        usedFilters?: FilterFormType | FilterFormType[]
    ) => (payload: { visibility?: BlockVisibilityProtocol; record?: RecordLikeProtocol }) => VISIBILITY_STATUS
}

export const DEFAULT_LAYOUT_CONTEXT_VALUE: FlowLayoutContextValue = {
    data: [],
    disabled: false,
    useParseVariableWithSubscription: () => {
        return () => void 0
    },
    useVisibilityFilter: () => {
        return () => VISIBILITY_STATUS.MOUNT
    }
}
const FlowLayoutContext = React.createContext(DEFAULT_LAYOUT_CONTEXT_VALUE)
export const FlowLayoutProvider = FlowLayoutContext.Provider
export const useFlowLayoutContext = () => React.useContext(FlowLayoutContext)

// 容器属性
export interface ContainerLayoutContextValue extends Partial<LayoutProperty> {
    parentId?: string
    level: number
}
export const DEFAULT_CONTAINER_CONTEXT: ContainerLayoutContextValue = {
    level: 0,
    size: {
        width: {
            size: 'fill'
        },
        height: {
            size: 'auto'
        }
    },
    layout: {
        align: {
            direction: 'vertical'
        }
    }
}
const ContainerLayoutContext = React.createContext(DEFAULT_CONTAINER_CONTEXT)
export const ContainerLayoutProvider = ContainerLayoutContext.Provider
export const useContainerLayoutContext = () => React.useContext(ContainerLayoutContext)
